import instance from '@src/api/common';

export function getMetricList(preferredVersion?: string) {
  return instance.get(
    `/v1/metrics${preferredVersion ? `?preferred_version=${preferredVersion}` : ''}`,
  );
}
